import React, { Component } from "react";
import { Modal, Form, Row, Col, Button } from "antd";
import InputForm from "./InputForm";
import { checkFormIsValid } from '../utils/Validator';
import "./Form.css";

const { Item: ItemForm } = Form;

export default class CondPagtoForm extends Component {
  state = {
    registro: {
      cp_codigo: '',
      cp_descricao: '',
      cp_parcelas: '',
      cp_qtde_parc: 1,
      cp_vlr_ped_ini: 0,
      cp_vlr_ped_fim: 0,
    }
  };


  componentDidUpdate(propsAnterior, stateAnterior) {
    if (this.props.registroSelecionado !== propsAnterior.registroSelecionado) {
      this.setState({
        registro: this.props.registroSelecionado
      }, () => {
        this.refs.cp_codigo.focus();
      });
    }
  }

  onChange = event => {
    const value = event.target.value;
    const id = event.target.id;

    const { registro } = this.state;
    registro[id] = value;

    this.setState({
      [id]: value
    });
  };

  onOK = () => {
    if ((!this.state.registro.cp_descricao) || (this.state.registro.cp_descricao === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe a Descrição' });
      return;
    }
    if ((!this.state.registro.cp_parcelas) || (this.state.registro.cp_parcelas === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe as Parcelas' });
      return;
    }
    if ((!this.state.registro.cp_qtde_parc) || (this.state.registro.cp_qtde_parc <= '0')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe a Quantidade de Parcelas' });
      return;
    }

    this.props.onSalvarClick(this.state.registro);
  };

  render() {
    const { onCancelarClick, carregando, visivel } = this.props;
    const { cp_idf, cp_codigo, cp_descricao, cp_parcelas, cp_qtde_parc, cp_vlr_ped_ini, cp_vlr_ped_fim } = this.state.registro;

    return (
      <Modal
        title={cp_idf ? "Edição de Cond. Pagto" : "Cadastro de Cond. Pagto"}
        visible={visivel}
        destroyOnClose
        onCancel={onCancelarClick}
        footer={null}
        width={"40%"}
        style={{ top: 30 }}
      >
        <Form>
          <Row>
            <Col xs={24} sm={4} style={{ paddingRight: 20 }}>
              <span>Código</span>
              <InputForm
                id="cp_codigo"
                ref="cp_codigo"
                maxLength={2}
                onChange={this.onChange}
                value={cp_codigo}
                validator={value => Boolean(value)}
                disabled={true}
              />
            </Col>

            <Col xs={24} sm={20}>
              <span>Descrição</span>
              <InputForm
                id="cp_descricao"
                ref="cp_descricao"
                maxLength={60}
                onChange={this.onChange}
                value={cp_descricao}
                validator={value => Boolean(value)}
              />
            </Col>

            <Col xs={24} sm={4} style={{ marginTop: -20, paddingRight: 20 }}>
              <span>Qtde Parc</span>
              <InputForm
                id="cp_qtde_parc"
                ref="cp_qtde_parc"
                value={cp_qtde_parc}
                maxLength={3}
                onChange={this.onChange}
                validator={value => Boolean(value)}
              />
            </Col>

            <Col xs={24} sm={20} style={{ marginTop: -20 }}>
              <span>Parcelas</span>
              <InputForm
                id="cp_parcelas"
                ref="cp_parcelas"
                maxLength={200}
                onChange={this.onChange}
                value={cp_parcelas}
                validator={value => Boolean(value)}
              />
            </Col>

            <Col xs={24} sm={12} style={{ marginTop: -20, paddingRight: 20 }}>
              <span>Vlr Inicial Pedido</span>
              <InputForm
                type="number"
                id="cp_vlr_ped_ini"
                ref="cp_vlr_ped_ini"
                value={cp_vlr_ped_ini}
                onChange={this.onChange}
              />
            </Col>

            <Col xs={24} sm={12} style={{ marginTop: -20 }}>
              <span>Vlr Final Pedido</span>
              <InputForm
                type="number"
                id="cp_vlr_ped_fim"
                ref="cp_vlr_ped_fim"
                value={cp_vlr_ped_fim}
                onChange={this.onChange}
              />
            </Col>

          </Row>
          <ItemForm>
            <Row>
              <Col xs={24}>
                 <Button
                  htmlType="button"
                  loading={carregando}
                  onClick={this.onOK}
                  className="botoesModalForm"
                >
                  Salvar
                </Button>

                <Button
                  htmlType="button"
                  onClick={onCancelarClick}
                  className="botoesModalFecharForm"
                >
                  Cancelar
                </Button>
              </Col>
            </Row>
          </ItemForm>

        </Form>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/CondPagtoForm.js